export default "__VITE_ASSET__B$f2m5pn__"